export const ADJUSTABLE_BASE_STRING = 'Adjustable Base'
export const HIDDEN_ADDONS_FOR_ADJUSTABLE_BASE = ['59951004', '59951016', '59955002', '59955014']
